module.exports = __webpack_public_path__ + "static/media/711.e396e065.gif";